module.exports = __webpack_public_path__ + "static/media/noTestTemp.4bc099bd.jpg";